module.exports = __webpack_public_path__ + "img/CS-ProfiNew-Info.e284347d.jpg";